import { REDUCER } from '../reducers/reducersConst';

const defaultClassRoomState = {
  activeClassrooms: [],
  archivedClassrooms: [],
  selectedClassroom: {
    classroom: {},
    participants: [],
    groups: [],
    classCodeIsOpen: false,
    fetchingParticipants: false,
    videocall: {}
  },
  addModalIsOpen: false,
  enrollModalIsOpen: false,
  submitTaskDataIsOpen: false,
  sendTaskDataIsSending: false,
  editRoleModalIsOpen: false,
  unenrollModalIsOpen: false,
  archiveModalClassroomData: null,
  importCSVModalIsOpen: false,
  failImportCSVModalIsOpen: false,
  notCanUploadFilesModalIsOpen: false,
  studentsErrors: [],
  csvFile: null,
  fetching: false
};

export const classrooms = (state = defaultClassRoomState, action) => {
  const getClassroomState = key => ({
    ...state,
    [key]: action[key]
  });

  const getSelectedClassroomState = key => ({
    ...state,
    selectedClassroom: {
      ...state.selectedClassroom,
      [key]: action[key]
    }
  });

  const states = {
    [REDUCER.CLASSROOM.SET_ACTIVE_CLASSROOM_DATA]: getClassroomState('activeClassrooms'),
    [REDUCER.CLASSROOM.SET_ARCHIVED_CLASSROOM_DATA]: getClassroomState('archivedClassrooms'),
    [REDUCER.CLASSROOM.SET_ADD_MODAL_STATE]: getClassroomState('addModalIsOpen'),
    [REDUCER.CLASSROOM.SET_ENROLL_MODAL_STATE]: getClassroomState('enrollModalIsOpen'),
    [REDUCER.CLASSROOM.SET_SUBMIT_TASK_DATA_STATE]: getClassroomState('submitTaskDataIsOpen'),
    [REDUCER.CLASSROOM.SEND_SUBMIT_TASK_DATA_STATE]: getClassroomState('sendTaskDataIsSending'),
    [REDUCER.CLASSROOM.SET_EDIT_ROLE_MODAL_STATE]: getClassroomState('editRoleModalIsOpen'),
    [REDUCER.CLASSROOM.SET_NOT_CAN_UPLOAD_FILES]: getClassroomState('notCanUploadFilesModalIsOpen'),
    [REDUCER.CLASSROOM.SET_UNENROLL_MODAL_STATE]: getClassroomState('unenrollModalIsOpen'),
    [REDUCER.CLASSROOM.SET_ARCHIVE_MODAL_DATA]: getClassroomState('archiveModalClassroomData'),
    [REDUCER.CLASSROOM.SET_IMPORT_MODAL_STATE]: getClassroomState('importCSVModalIsOpen'),
    [REDUCER.CLASSROOM.SET_FAIL_IMPORT_MODAL_STATE]: getClassroomState('failImportCSVModalIsOpen'),
    [REDUCER.CLASSROOM.SET_FAIL_IMPORT_STUDENTS_ERRORS]: getClassroomState('studentsErrors'),
    [REDUCER.CLASSROOM.SET_CSV_FILE_UPLOADED]: getClassroomState('csvFile'),
    [REDUCER.CLASSROOM.FETCHING]: getClassroomState('fetching'),
    [REDUCER.SEL_CLASSROOM.SET_CLASSROOM_INFO]: getSelectedClassroomState('classroom'),
    [REDUCER.CLASSROOM.FETCHING_PARTICIPANTS]: getSelectedClassroomState('fetchingParticipants'),
    [REDUCER.SEL_CLASSROOM.SET_CLASSROOM_PARTICIPANTS]: getSelectedClassroomState('participants'),
    [REDUCER.SEL_CLASSROOM.SET_CLASSROOM_GROUPS]: getSelectedClassroomState('groups'),
    [REDUCER.SEL_CLASSROOM.SET_CLASSCODE_POPUP_STATE]: getSelectedClassroomState('classCodeIsOpen'),
    [REDUCER.CLASSROOM.SET_ACTIVE_TAB]: getSelectedClassroomState('activeClassroomTab'),
    [REDUCER.SEL_CLASSROOM.SET_VIDEOCALL_INFO]: getSelectedClassroomState('videocall')
  };

  return states[action.type] || state;
};

const defaultStudentState = {
  selectedStudent: undefined
};

export const student = (state = defaultStudentState, action) => {
  const getStudentState = key => ({
    ...state,
    [key]: action.selectedStudent
  });

  const states = {
    [REDUCER.STUDENT.SET_SELECTED_PROFILE]: getStudentState('selectedStudent')
  };

  return states[action.type] || state;
};
